define('Components/PageHeaderWidget/js/views/PageHeaderV2View',['jquery',
        'app',
        'Components/PageHeaderWidget/js/views/PageHeaderWidgetInstanceView',
        'template!Components/PageHeaderWidget/templates/home-v2',
        'InternalLinkView'
    ],
    function ($, app, PageHeaderWidgetInstanceView, PageHeaderV2Template, InternalLinkView) {
        return PageHeaderWidgetInstanceView.extend({
            name: 'PageHeaderV3View',
            getTemplate: function () {
                return PageHeaderV2Template;
            }
        })
    });
